import type { ModalidadeEnsino } from '../types/database'
import { MODALIDADE_GRUPOS_ATIVOS, type ModalidadeGrupoId } from './modalidadeGrupos'

/** Chaves `cardapios.modalidade` gravadas para o grupo (Infantil → só `pre`). */
export function modalidadesDbDoGrupo(grupoId: ModalidadeGrupoId): ModalidadeEnsino[] {
  const grupo = MODALIDADE_GRUPOS_ATIVOS.find((g) => g.id === grupoId)
  return grupo ? [...grupo.keys] : ['pre']
}

/** Chave preferida na leitura (Infantil → pre). */
export function modalidadeLeituraCardapio(grupoId: ModalidadeGrupoId): ModalidadeEnsino {
  const grupo = MODALIDADE_GRUPOS_ATIVOS.find((g) => g.id === grupoId)
  if (!grupo) return 'pre'
  if (grupo.id === 'infantil') return grupo.importPnaeKey
  return grupo.keys[0]
}
